<template>
  <PaginatedTable
    id="pagamentos-retirados"
    ref="table"
    title="Retiradas"
    hideSearch
    :headers="cabecalho"
    :sort-desc="true"
    :data-fetcher="api.pagamentos.indexarRetirados"
    @click:row="handleClickRow"
  ></PaginatedTable>
</template>

<script>
import api from "@/services/locacoes";

import PaginatedTable from "@/components/server/PaginatedTable.vue";

export default {
  mixins: [],

  components: {
    PaginatedTable
  },

  props: {},

  data() {
    return {
      api,

      cabecalho: [
        {
          text: "Código",
          value: "id",
          sortable: false
        },
        {
          text: "Total",
          value: "locacoes_total",
          sortable: false
        },
        {
          text: "Data",
          value: "created_at",
          sortable: false
        },
        {
          text: "Locações",
          value: "locacoes_qtd",
          sortable: false
        },
        {
          text: "Responsável",
          value: "nome_usuario",
          sortable: false
        }
      ]
    };
  },

  methods: {
    handleClickRow(item) {
      this.$router.push({
        name: "locacoes_pagamentos_retirados_detalhes_page",
        params: {
          id: item.id
        }
      });
    }
  },

  computed: {}
};
</script>
